<template>
  <!-- Modal -->
  <div class="modal fade" :id="name" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Select Task</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-show="selectedTask=='none'">
            <a :data-task="element.name" v-on:click="selectTask(element.name)" :to="'/admin/device/create/' + element.url" class="task list-group-item" v-for="element in tasks">
              <div class="d-flex w-100 justify-content-between">
                <p style="font-size:15px">{{element.name}}</p>
              </div>
              <small>{{element.description}}</small>
            </a>
          </div>
          <locationtag ref="locationTag" v-show="selectedTask=='locationtag'"></locationtag>
          <datainput ref="input" v-show="selectedTask=='input'"></datainput>
          <temperature ref="temperature" v-show="selectedTask=='temperature'"></temperature>
        </div>
        <div class="modal-footer">
          <button v-show="selectedTask=='none'" type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button v-show="selectedTask!='none'" v-on:click="showAllTasks" type="button" class="btn btn-secondary">Back</button>
          <button v-show="selectedTask!='none'" v-on:click="addTask" data-dismiss="modal" type="button" class="btn btn-success">Add</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LocationTag from './LocationTag'
import Input from './Input'
import Temperature from './Temperature'


export default {
  components: {
    'locationtag':LocationTag,
    'datainput':Input,
    'temperature':Temperature,
  },
  props: {
    name: {
      type: String
    }
  },
  data() {
    return {
        tasks:[
          {name:"Location Tag",description:"Ask user to tag a location.",url:"locationtag"},
          {name:"Input",description:"Ask user for input.",url:"input"},
          {name:"Temperature",description:"Ask user to use a thermometer.",url:"temperature"}
        ],
        selectedTask: 'none',
        task: {}
    }
  },
  methods: {
    showAllTasks: function(){
      this.selectedTask = 'none'
    },
    selectTask: function(task) {
       var task = task.replace(/\s+/g, '');
       task = task.toLowerCase()
       this.selectedTask = task
    },
    addTask:function(){
      var task = {}
      switch(this.selectedTask){
        case 'locationtag': 
          task = {
            'locationtag':{
              id: this.$refs.locationTag.locationtag['.key'],
              name: 'Location Tag',
              description: this.$refs.locationTag.locationtag['name'],
              speak: this.$refs.locationTag.speak
            }
          }
          break;
        case 'input': 
          var inputType = this.$refs.input.input['type']
          task = {
            'input':{
              type: inputType,
              name: 'Input',
              description: this.$refs.input.input['name'],
            }
          }
          break;
        case 'temperature': 
          task = {
            'temperature':{
              name: 'Temperature',
              description: this.$refs.temperature.temperature['name'],
            }
          }
          break;
      }
      this.selectedTask = 'none'
      this.$emit('addTask', task)
    }
  }
}
</script>

<style scoped>
.task p{
  color: #000
}
.task small{
  color: #000
}
.task:hover {
    z-index: 2;
    color: #fff;
    background-color: #46B3E4;
    border-color: #46B3E4;
}
.task:hover p {
  color: #fff
}
.task:hover small {
  color: #fff
}
</style>


// WEBPACK FOOTER //
// CreateTaskModal.vue?6e317c73